var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "chat-btm-section-main width-full float-l" },
              [
                _c(
                  "h2",
                  {
                    staticClass:
                      "chat-page-title float-l width-full color-333333 heading-text-24 line-height-28 font-bold ucase"
                  },
                  [_vm._v(" Site list ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "chat-sitelist-web border-d1d3d4 float-l col-12"
                  },
                  [
                    _vm.mySiteArr && _vm.mySiteArr.length > 0
                      ? _vm._l(_vm.mySiteArr, function(site, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 float-l internal-sile-list"
                            },
                            [
                              _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "site-listing-section-web float-l"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "site-list-section width-full float-l relative border-none"
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-4"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "right-site-list-section float-l width-full pl_50"
                                        },
                                        [
                                          _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("filterString")(
                                                      site.sectionName
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"
                                            },
                                            [
                                              _vm._v(
                                                " Role: " +
                                                  _vm._s(
                                                    _vm._f("filterString")(
                                                      site.roleName
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        })
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.mySiteArr && _vm.mySiteArr.length > 0
                  ? _vm._l(_vm.mySiteArr, function(site, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "site-list-mobile float-l width-full"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "site-list-section col-12 float-l relative pt_20 pb_20 border-none"
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-25"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "right-site-list-section float-l width-full pl_35"
                                },
                                [
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("filterString")(
                                              site.sectionName
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"
                                    },
                                    [
                                      _vm._v(
                                        " Role: " +
                                          _vm._s(
                                            _vm._f("filterString")(
                                              site.roleName
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cbaf014", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cbaf014","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List/SiteList.vue
// module id = null
// module chunks = 